type InboxSupportFeedbackEventsBaseArgs = {
  threadId: string
  helpCenterSessionId: string
}

type InboxActionButtonEventsArgs = InboxSupportFeedbackEventsBaseArgs & {
  supportType: string
}

export const endContinueActionsViewedEvent = (args: InboxActionButtonEventsArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
    support_type: args.supportType,
  }

  return {
    event: 'support_conversation_actions.end_continue_actions_viewed',
    extra,
  }
}

export const endConversationClicked = (args: InboxActionButtonEventsArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
    support_type: args.supportType,
  }

  return {
    event: 'support_conversation_actions.end_conversation_clicked',
    extra,
  }
}

export const agentSupportFeedbackClosed = (args: InboxSupportFeedbackEventsBaseArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'agent_support_feedback.feedback_closed',
    extra,
  }
}

export const agentSupportFeedbackV1Viewed = (args: InboxSupportFeedbackEventsBaseArgs) => {
  const extra = {
    thread_id: args.threadId,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'agent_support_feedback.feedback_v1_viewed',
    extra,
  }
}
